import type { NavSection } from '@/lib/types';
import NavigationList from './NavigationList';
import styles from './Sidebar.module.css';

interface SidebarProps {
  sections: NavSection[];
  activePath: string;
  collapsed: boolean;
}

export default function Sidebar({ sections, activePath, collapsed }: SidebarProps) {
  return (
    <aside className={`${styles.sidebar}${collapsed ? ` ${styles.sidebarCollapsed}` : ''}`}>
      <nav aria-label="Sidebar navigation">
        {sections.map((section, index) => (
          <section className={styles.navSection} key={section.label ?? `primary-${index}`}>
            {section.label && !collapsed && <h2>{section.label}</h2>}
            {section.label && collapsed && <div className={styles.sectionDivider} aria-hidden="true" />}
            <NavigationList
              items={section.items}
              activePath={activePath}
              listClassName={styles.sidebarNav}
              linkClassName={styles.sidebarLink}
              activeClassName={styles.sidebarLinkActive}
              collapsed={collapsed}
            />
          </section>
        ))}
      </nav>
    </aside>
  );
}
